require.register("app/supplier/RangeView", function(exports, require, module){
  $0
  
});

